import Richtext from './richtext';
import Link from './link';

type Subscription = {
  buttonLabel: string;
  errorMessage: string;
  placeholder: string;
  successMessage: string;
  title: string;
};

type Social = {
  title: string;
  links: Link[];
};

type TextSignup = {
  title: string;
  subTitle: string;
  placeHolder: string;
  buttonLabel: string;
  successMessage: string;
  errorMessage: string;
  consent: Richtext | null;
  agreeToReceiveMessages: string;
};

export class Footer {
  bottomLinks: Link[];
  fontColor: string;
  legal: Richtext | null;
  links: Link[];
  social: Social;
  subscription: Subscription;
  textSignup: TextSignup;

  constructor(props: any) {
    this.fontColor = props.fontColor;
    this.legal = props.legal ? new Richtext(props.legal) : null;
    this.links = props?.linksCollection?.items?.map((l: any) => new Link(l));
    this.bottomLinks = props?.bottomLinksCollection?.items?.map(
      (l: any) => new Link(l)
    );
    this.social = {
      title: props.socialTitle,
      links: props?.socialLinksCollection?.items?.map((l: any) => new Link(l))
    };
    this.subscription = {
      buttonLabel: props.subscriptionButtonLabel,
      errorMessage: props.subscriptionErrorMessage,
      placeholder: props.subscriptionPlaceholder,
      successMessage: props.subscriptionSuccessMessage,
      title: props.subscriptionTitle
    };
    this.textSignup = {
      title: props.textSignupTitle,
      subTitle: props.textSignupSubTitle,
      placeHolder: props.textSignupPlaceholder,
      buttonLabel: props.textSignupButtonLabel,
      successMessage: props.textSignupSuccessMessage,
      errorMessage: props.textSignupErrorMessage,
      consent: props.textSignupConsent,
      agreeToReceiveMessages: props.textSignupConsentToReceiveMessages
    };
  }
}

export default Footer;
